import { render, staticRenderFns } from "./educationArrivalDate.vue?vue&type=template&id=2a642752"
import script from "./educationArrivalDate.vue?vue&type=script&lang=js"
export * from "./educationArrivalDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a642752')) {
      api.createRecord('2a642752', component.options)
    } else {
      api.reload('2a642752', component.options)
    }
    module.hot.accept("./educationArrivalDate.vue?vue&type=template&id=2a642752", function () {
      api.rerender('2a642752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/educationArrivalDate.vue"
export default component.exports